import { createSlice } from '@reduxjs/toolkit'

export const FilterReducer = createSlice({
    name: 'filtersData',
    initialState: {
        FiltersData: {
            filter: '',
            orderBy: '',
            pageSize: '',
            pageNumber: ''
        },
    },
    reducers: {
        setFiltersData: (state, action) => {
            state.FiltersData = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setFiltersData } = FilterReducer.actions

export default FilterReducer.reducer